import { CABINET_BASE_URL } from "@/config/const";
import { Message } from "@/types";
import { NotificationDto, SendMessage } from "@/types/notifications";
import apiService from "../api.service";
import { ListOptions } from "./types";

const messageURL = `${CABINET_BASE_URL}rest/message/`;
const baseURL = `${CABINET_BASE_URL}rest/notification/`;
const securityURL = `${CABINET_BASE_URL}rest/security/`;

export interface BaseMailParams {
  notificationType: string;
  searchText?: string;
}

export default {
  async downloadMessageFile(
    docGuid: string,
    messageGuid: string,
    messageId: number
  ): Promise<any> {
    return await apiService.get(`${messageURL}file`, {
      params: { docGuid, messageGuid, messageId },
      responseType: "blob",
    });
  },
  getLawmen() {
    return apiService.get(`${baseURL}lawman`, {
      params: { notificationType: "0" },
    });
  },
  sendMessage(message: SendMessage) {
    return apiService.post(`${messageURL}`, message);
  },
  getMessages(p: ListOptions, b: BaseMailParams) {
    return apiService.post(`${baseURL}search`, b, { params: p.toHttpParams() });
  },
  async getCount() {
    return apiService.get(`${securityURL}data_quantity_counters`);
  },
  async getNotificationsQueue(): Promise<NotificationDto[]> {
    return (await apiService.get(`${baseURL}priority`)).data;
  },
  setRead(
    notificationGuid: string,
    notificationId: string | number,
    isNotification?: boolean
  ) {
    return apiService.put(baseURL, null, {
      params: { isNotification, notificationGuid, notificationId },
    });
  },
  async getMessage(
    notificationGuid: string,
    notificationId: string,
    isNotification?: boolean
  ): Promise<Message> {
    return (
      await apiService.get(`${baseURL}`, {
        params: { isNotification, notificationGuid, notificationId },
      })
    ).data;
  },
};
